export default {
    inventoriesGroups: [],
    indirectExpenses: [],
    indirectExpensesFiltered: [],
    articles: [],
    articlesFiltered: [],
    ivaTypes: [],
    ivaTypesFiltered: [],
    newEntrance: [],
    newEntranceFiltered: [],
    allPackagings: []
}